/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay } from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay';
import {
    instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSON,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSONTyped,
    FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSON,
} from './FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay';

/**
 * @type FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay
 * 
 * @export
 */
export type FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay = FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay;

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay(json)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSON(json: any): any {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlayToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsVkontaktePlay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay(value)) {
        return FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlayToJSON(value as FxIdApplicationPublicDataBuilderPlatformDataOptionsPlatformDataOptionsVkontaktePlay);
    }

    return {};
}

